const updateAnimationDuration = () => {
    // Select all elements with the class `animate-translate-x-full` or `animate-translate-x-full-reverse`
    const elements = document.querySelectorAll('.animate-translate-x-full, .animate-translate-x-full-reverse');

    elements.forEach(element => {
        // Get the width of the container
        const containerWidth = element.offsetWidth;

        // Calculate the animation duration in milliseconds
        const animationDuration = (containerWidth / 50) * 1000; // 50px per second

        // Get the current animation duration from the element's style
        const currentDuration = parseFloat(getComputedStyle(element).animationDuration);

        // Update the animation duration only if it has changed
        if (currentDuration !== animationDuration / 1000) { // Convert animationDuration to seconds for comparison
            element.style.animationDuration = `${animationDuration}ms`;
        }
    });
};

// Create a debounced version of the function
const debouncedUpdate = _debounce(updateAnimationDuration, 300);

// Run on page load
window.addEventListener('load', debouncedUpdate);

// Run on window resize
window.addEventListener('resize', debouncedUpdate);
